<template>
  <div id="app">
	  <c-header/>

	  <!-- hero -->
	  <s-hero/>

	  <!-- ceo -->
		<s-ceo/>

		<!-- the company -->
		<s-company/>

		<!-- fiber -->
    <s-fiber/>

		<!-- business areas -->
    <s-business/>

		<!-- innovation -->
    <s-innovation/>

		<!-- sustainability -->
		<s-sustainability/>

		<!-- financials -->
    <s-financials/>

	  <c-footer/>
  </div>
</template>

<script>

	// components
	import CHeader 	from './components/Header.vue';
	import CFooter 	from './components/Footer.vue';

	// sections
  import SHero 	from './sections/Hero.vue';
  import SCeo 	from './sections/Ceo.vue';
  import SCompany 	from './sections/Company.vue';
  import SFiber	from './sections/Fiber.vue';
  import SBusiness	from './sections/Business.vue';
  import SInnovation	from './sections/Innovation.vue';
  import SSustainability	from './sections/Sustainability.vue';
  import SFinancials	from './sections/Financials.vue';


	export default {
	  name: 'App',
	  components: {
		  CHeader,
		  CFooter,
      SHero,
      SCeo,
      SCompany,
      SFiber,
      SBusiness,
      SInnovation,
      SSustainability,
      SFinancials
	  }
	}
</script>

<style lang="scss">
	@import "~bootstrap/scss/functions";
	@import "~bootstrap/scss/variables";

	/* custom variables */
	@import "./assets/css/custom-variables";

	/* core */
	@import "~bootstrap/scss/mixins";
	@import "~bootstrap/scss/print";
	@import "~bootstrap/scss/reboot";
	@import "~bootstrap/scss/grid";
	@import "~bootstrap/scss/utilities";
	@import "~bootstrap/scss/type";

	/* components */
	@import "~bootstrap/scss/nav";
	@import "~bootstrap/scss/navbar";
	@import "~bootstrap/scss/forms";
	@import "~bootstrap/scss/custom-forms";
	@import "~bootstrap/scss/buttons";
	@import "~bootstrap/scss/transitions";
	@import "~bootstrap/scss/dropdown";
	@import "~bootstrap/scss/images";
	@import "~bootstrap/scss/modal";
	@import "~bootstrap/scss/close";

	/* add components over this line for use
	@import "~bootstrap/scss/button-group";
	@import "~bootstrap/scss/input-group";
	@import "~bootstrap/scss/alert";
	@import "~bootstrap/scss/progress";
	@import "~bootstrap/scss/list-group";
	@import "~bootstrap/scss/card";
	@import "~bootstrap/scss/breadcrumb";
	@import "~bootstrap/scss/tables";
	@import "~bootstrap/scss/badge";
	@import "~bootstrap/scss/tooltip";
	@import "~bootstrap/scss/code";
	@import "~bootstrap/scss/pagination";
	@import "~bootstrap/scss/media";
	@import "~bootstrap/scss/popover";
	@import "~bootstrap/scss/jumbotron";
	@import "~bootstrap/scss/carousel";*/

	/* custom css for this page */
	@import "./assets/css/app";
</style>



// WEBPACK FOOTER //
// src/App.vue